import React from 'react';
import $ from 'jquery';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as fa from '@fortawesome/free-solid-svg-icons';

class NavigationBar extends React.Component{

    state = {
        style : {},
        mobileMenu: ""
    }

    componentDidMount(){
        window.addEventListener('scroll', () => this.changeNav(this.props.fields.color?this.props.fields.color:this.props.primeColor));
        $(".navigation-bar-menu a").hover((e) => {
            if(!$(e.currentTarget).parent().hasClass("button"))
                $(e.currentTarget).css("color", this.props.secondColor);
        }, (f) => {
            $(f.currentTarget).removeAttr("style");
        });
    }

    changeNav(primeColor){
        if($(window).scrollTop() === 0){
            this.setState({
                style: {}
            })
        }else{
            this.setState({
                style: {
                    backgroundColor:primeColor
                }
            })
        }
    }

    displayMobileMenu = () => {
        if(this.state.mobileMenu===""){
            this.setState({
                mobileMenu: <div className="mobile-menu">
                    {this.props.fields.menuText.map((text, i) => {
                        if(text.includes("[")){
                            return <div className="row navigation-bar-menu button">
                                <a href={this.props.fields.menuPath[i]}>{text.replace("[","").replace("]","")}</a>
                            </div>
                        }else{
                            return <div className="row navigation-bar-menu">
                                <a href={this.props.fields.menuPath[i]}>{text}</a>
                            </div>
                        }
                    })}
                </div>
            })
        }else{
            this.setState({
                mobileMenu: ""
            })
        }
    }

    render(){
        return [
            <div class="row navigation-bar" style={this.state.style}>
                <div className="col-2 navigation-bar-logo"
                     style={{backgroundImage: "url("+this.props.fields.logo.fields.file.url+")"}}
                     onClick={() => window.location.pathname="/"}
                ></div>
                {this.props.fields.menuText.map((text, i) => {
                    if(text.includes("[")){
                        return <div className="col-1 navigation-bar-menu pull-right button">
                            <a href={this.props.fields.menuPath[i]}>{text.replace("[","").replace("]","")}</a>
                        </div>
                    }else{
                        return <div className={"col-1 navigation-bar-menu "+(i===0?"offset-5":"")}>
                            <a href={this.props.fields.menuPath[i]}>{text}</a>
                        </div>
                    }
                })}
            </div>,
            <div class="row navigation-bar-mobile" style={this.state.style}>
                <div className="col-6 navigation-bar-logo"
                    style={{backgroundImage: "url("+this.props.fields.logo.fields.file.url+")"}}
                    onClick={() => window.location.pathname="/"}
                ></div>
                <div className="col-2 offset-4 navigation-bar-menuButton" onClick={this.displayMobileMenu}>
                    <FontAwesomeIcon icon={this.state.mobileMenu===""?fa.faBars:fa.faTimes}/>
                </div>
                {this.state.mobileMenu}
            </div>
        ]
    }
}

export default NavigationBar;
